var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2269 7.59092C14.0147 7.37878 13.7572 7.27279 13.4541 7.27279H13.0906V5.09085C13.0906 3.69693 12.5908 2.50007 11.5907 1.50007C10.5908 0.500022 9.39401 0 7.9999 0C6.60582 0 5.40884 0.500022 4.40895 1.50003C3.40891 2.50007 2.90905 3.69689 2.90905 5.09085V7.27279H2.54546C2.24253 7.27279 1.9849 7.37878 1.77276 7.59092C1.56062 7.8029 1.45459 8.06054 1.45459 8.36374V14.9091C1.45459 15.2121 1.56066 15.4698 1.77276 15.6819C1.9849 15.8939 2.24253 16 2.54546 16H13.4543C13.7575 16 14.0149 15.894 14.2272 15.6819C14.4391 15.4698 14.5453 15.2121 14.5453 14.9091V8.36362C14.5455 8.06066 14.4391 7.80306 14.2269 7.59092ZM10.9089 7.27279H5.09087V5.09085C5.09087 4.28786 5.37501 3.60221 5.94317 3.03412C6.51141 2.46596 7.19695 2.18194 8.00002 2.18194C8.80316 2.18194 9.48854 2.46592 10.0568 3.03412C10.6248 3.60217 10.9089 4.28786 10.9089 5.09085V7.27279Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default ForwardRef;